import styled, {createGlobalStyle, css} from "styled-components";
import * as HomeStyles from './components/home/HomeStyles';
import * as GeneralStyles from './components/ReUsableStyles';
import * as HomeSectionStyles from './components/homeSection/HomeSectionStyles';
import {SkillsTitle as SkillsTitle, SkillsContainer} from './components/skills/SkillsStyles'
import {Data as QualificationData} from './components/qualification/QualificationStyles'
import {Container as ServicesContainer, Content as ServicesContent, ServicesModal, ModalContent} from './components/services/ServicesStyles';
import {Img as ProjectImg,Data as ProjectData, Container as ProjectContainer, ProjectBg,Section as ProjectSection, ProjectTitle,} from './components/project/ProjectStyles';
import {Content as TestimonialContent,Description as TestimonialDesc, TestifierTypeAndRating,Img as TestimonialImg, TestimonialHeader, TestifierName} from './components/testimonials/TestimonialStyles';
import {Container as AboutContainer,Info as AboutInfo, AboutBtns,Desc as AboutDescription, AboutImg} from './components/about/AboutStyles';
import {QualificationSection, Tabs as qualificationTabs, ButtonWrapper as QualificationBtn, QualificationWrapper} from './components/qualification/QualificationStyles';
import {Content as PortfolioContent,Data as PortfolioData, ContentImg as portfolioImg,Button as PortfolioBtn, Desc as portfolioDescription, SlideArrow} from './components/portfolio/PortfolioStyles';
import {Container as ContactContainer, Form, Input as FormInput, InputsWrapper} from './components/contact/ContactStyles';
import {FooterBackground, FooterContainer, FooterCopyright, FooterLinksWrapper, FooterSocial, FooterSocialsWrapper} from './components/footer/FooterStyles';

export const Global = createGlobalStyle`

/*==================== GOOGLE FONTS ====================*/


/*==================== VARIABLES CSS ====================*/
:root {

    --header-height: 3rem;

    /*========== Colors ==========*/
    /* Change favorite color */
    --hue-color: 356; /*--356 Purple 250 - Green 142 - Blue 230 - Pink 340*/

    --first-color: hsl(var(--hue-color), 69%, 61%);
    
    --first-color-alt:hsl(var(--hue-color), 57%, 53%) ;
    --first-color-lighter: hsl(var(--hue-color), 92%, 85%);
    --text-color-light: hsl(var(--hue-color), 8%, 65%);
    ${props =>props.theme.mode !== 'dark'
        ?css`
        /* HSL color mode */
        --first-color-second:hsl(var(--hue-color), 69%, 61%) ;
        --title-color:hsl(var(--hue-color), 8%, 15%) ;
        --text-color: hsl(var(--hue-color), 8%, 45%);
        --input-color:hsl(var(--hue-color), 70%, 96%) ;
        --body-color: hsl(var(--hue-color), 60%, 99%);
        --container-color: #fff;
        --scroll-bar-color: hsl(var(--hue-color), 12%, 90%);
        --scroll-thumb-color: hsl(var(--hue-color), 12%, 80%);
        `
        :css`
        /* HSL color mode */
        --first-color-second:hsl(var(--hue-color), 30%, 8%) ;
        --title-color:hsl(var(--hue-color), 8%, 95%) ;
        --text-color: hsl(var(--hue-color), 8%, 75%);
        --input-color:hsl(var(--hue-color), 29%, 16%) ;
        --body-color: hsl(var(--hue-color), 28%, 12%);
        --container-color: hsl(var(--hue-color), 29%, 16%);
        --scroll-bar-color: hsl(var(--hue-color), 12%, 48%);
        --scroll-thumb-color: hsl(var(--hue-color), 12%, 36%);
        `
    }
    

    /*========== Font and typography ==========*/
    --body-font: 'Poppins', sans-serif;

    /* .5rem = 8px, 1rem = 16px, 1.5rem = 24px ... */
    --big-font-size: 2rem;
    --h1-font-size: 1.5rem;
    --h2-font-size: 1.25rem;
    --h3-font-size: 1.125rem;
    --normal-font-size: .938rem;
    --small-font-size: .813rem;
    --smaller-font-size: .75rem;

    /*========== Font weight ==========*/
    --font-medium: 500;
    --font-semi-bold: 600;

    /*========== Margines Bottom ==========*/
    /* .25rem = 4px, .5rem = 8px, .75rem = 12px ... */
    --mb-0-25: .25rem;
    --mb-0-5: .5rem;
    --mb-0-75: .75rem;
    --mb-1: 1rem;
    --mb-1-5: 1.5rem;
    --mb-2: 2rem;
    --mb-2-5: 2.5rem;
    --mb-3: 3rem;

    /*========== z index ==========*/
    --z-tooltip: 10;
    --z-fixed: 100;
    --z-modal: 1000;
}

/* Font size for large devices */
@media screen and (min-width: 968px) {
    :root {
        --big-font-size: 3rem;
        --h1-font-size: 2.25rem;
        --h2-font-size: 1.5rem;
        --h3-font-size: 1.25rem;
        --normal-font-size: 1rem;
        --small-font-size: .875rem;
        --smaller-font-size: .813rem;
    }
}

/*========== Variables Dark theme ==========*/
body.dark-theme{
    /* HSL color mode */
    --first-color-second:hsl(var(--hue-color), 30%, 8%) ;
    --title-color:hsl(var(--hue-color), 8%, 95%) ;
    --text-color: hsl(var(--hue-color), 8%, 75%);
    --input-color:hsl(var(--hue-color), 29%, 16%) ;
    --body-color: hsl(var(--hue-color), 28%, 12%);
    --container-color: hsl(var(--hue-color), 29%, 16%);
    --scroll-bar-color: hsl(var(--hue-color), 12%, 48%);
    --scroll-thumb-color: hsl(var(--hue-color), 12%, 36%);
}

/*========== Button Dark/Light ==========*/


/*==================== BASE ====================*/
    *{
        margin:0;
        padding:0;
        box-sizing:border-box;
    }

    html{
        scroll-behavior: smooth;
    }

    body{
        margin: 0 0 var(--header-height) 0;
        font-family: var(--body-font);
        font-size: var(--normal-font-size);
        background-color:var(--body-color);
        color: var(--text-color);
        
    }

    h1,h2,h3,h4{
        color: var(--title-color);
        font-weight: var(--font-semi-bold);
    }

    ul{
        list-style: none;
    }

    a{
        text-decoration: none;
    }

    img{
        max-width: 100%;
        height:auto;
    }

/*========== SCROLL BAR ==========*/
::-webkit-scrollbar{
    width: .60rem;
    background-color: var(--scroll-bar-color);
    border-radius: .5rem;
}
::-webkit-scrollbar-thumb{
    background-color: var(--scroll-thumb-color);
    border-radius: .5rem;
    :hover{
        background-color: var(--text-color-light);
    }
}

/*==================== MEDIA QUERIES ====================*/
/* For small devices */
@media screen and (max-width: 350px){
    ${GeneralStyles.Container}{
        margin-left: var(--mb-1);
        margin-right: var(--mb-1);
    }
    
    ${HomeStyles.NavMenu}{
        padding: 2rem .25rem 4rem;
    }
    ${HomeStyles.NavList}{
        column-gap: 0;
    }
    ${HomeSectionStyles.Content}{
        grid-template-columns: .25fr 3fr;
    }
    ${HomeSectionStyles.HomeImg}{
        .home__blob{
            width: 180px;
        }
    }
    ${SkillsTitle}{
        font-size: var(--normal-font-size);
    }
    ${QualificationData}{
        gap: .15rem;
    }
    ${ServicesContainer}{
        grid-template-columns:max-content;
        justify-content: center;
    }
    ${ServicesContent}{
        padding-right:3.5rem;
    }
    ${ServicesModal}{
        padding: 0 .5rem;
    }
    ${ProjectImg}{
        width:200px;
    }
    ${TestimonialHeader}{
        
        flex-direction: column;
        align-items:center;
        
    }
    ${TestimonialImg}{
        margin-bottom: var(--mb-0-25);
        margin-right: 3.5rem;
    }
    ${TestifierName}{
        width: calc(100vw - 50vw);
        margin-left: 2rem;
    }
    ${TestifierTypeAndRating}{
        width: calc(100vw - 40vw);
        margin-right: 2rem;
    }
}

/* For medium devices */
@media screen and (min-width: 568px){
    ${HomeStyles.NavLogo}{
        font-size:var(--mb-2);
    }
    ${HomeSectionStyles.Content}{
        grid-template-columns: max-content 1fr 1fr;
    }
    ${HomeSectionStyles.HomeData}{
        grid-column: initial;
    }
    ${HomeSectionStyles.HomeImg}{
        order: 1;
        justify-self: center;
    }
    ${AboutContainer},
      ${ProjectContainer},
       ${ContactContainer},
       ${FooterContainer}{
        grid-template-columns: repeat(2, 1fr);
    }
    ${PortfolioContent}{
        grid-template-columns: 1fr 2fr;
        // padding:0;
    }
    ${portfolioImg}{
        justify-self: start;
    }
    ${PortfolioData}{
        width:100%;
        
    }
    ${portfolioDescription}{
        // height:50%;
        // justify-self:start;
    }

    ${QualificationSection}{
        display:grid;
        grid-template-columns: .7fr;
        justify-content: center;
    }
    // ${TestimonialContent}{
    //     // max-width:calc(100vw - 400px);
    
    //     max-width:600px;
    //     display: flex;
    //     flex-direction:column;
    //     justify-content:center;
    //     align-items:center;
    //     padding:0 2rem;
    // }
    // ${TestimonialDesc}{
    //     // justify-self:center;
    //     align-self: center;
    //     padding:0;
    //     max-width: 90%;
    
    // }
}

@media screen and (min-width: 768px){
    body{
        margin:0;
    }

    // the other styles peculiar to this screen size reside in the reusableStyles component

    ${HomeStyles.Header}{
        top:0;
        bottom: initial;
    }
    ${HomeStyles.Header},
     ${HomeStyles.Main}, 
     ${FooterContainer}{
        padding: 0 1rem;
    }
    ${HomeStyles.Nav}{
        height: calc(var(--header-height) + 1.5rem);
        column-gap:1rem;
    }
     
    ${HomeStyles.Navclose}, 
    ${HomeStyles.NavToggle}
    {
        display:none;
    }

    ${HomeStyles.NavLink}{
        .nav-icon{
            display:none;
        }
    }

    ${HomeStyles.NavList}{
        display:flex;
        column-gap: 2rem;
    }

    ${HomeStyles.NavMenu}{
        margin-left: auto;   
    }

    ${HomeStyles.NavBtns}{
        .change-theme{
            margin:0;
        }   
    }
    ${HomeSectionStyles.Container}{
        row-gap: 5rem;
    }
    ${HomeSectionStyles.Content}{
        padding-top: 5.5rem;
        column-gap: 2rem;
    }
    ${HomeSectionStyles.HomeImg}{
        .home__blob{
            width: 270px;
        }
    }
    ${HomeSectionStyles.HomeScroll}{
        display:block;
    }
    ${HomeSectionStyles.HomeScrollBtn}{
        margin-left: 3rem;
    }
    ${AboutContainer}{
        column-gap: 5rem;
    }
    ${AboutImg}{
        width: 300px;//350px intuts
    }
    ${AboutDescription}{
        text-align: initial;
    }
    ${AboutInfo}{
        justify-content: space-between;
    }
    ${AboutBtns}{
        justify-content: initial;
    }
    ${SkillsContainer}{
        grid-template-columns: repeat(2, 1fr);
    }
    ${qualificationTabs}{
        justify-content: center;
    }
    ${QualificationBtn}{
        margin: 0 var(--mb-1);
    }
    ${QualificationWrapper}{
        grid-template-columns: .5fr;
    }
    ${ServicesContainer}{
        grid-template-columns: repeat(3, 218px);
        justify-content: center; 
    }
    ${ServicesContent}{
        padding: 6rem 0 2rem 2.5rem;

        .service-icon{
            font-size: 2rem;
        }
    }
    ${ModalContent}{
        width: 450px;
    }
    ${portfolioImg}{
        width: 320px;
    }
    ${PortfolioContent}{
        align-items:center;
        // padding:0;
    }
    ${PortfolioBtn}{
        margin:0;
    }
    ${portfolioDescription}{
        max-width: 400px;
    }

    ${ProjectSection}{
        text-align: initial;
    }
    ${ProjectBg}{
        background: none;
    }
    ${ProjectContainer}{
        background-color: var(--first-color-second);
        border-radius: 1rem;
        padding: 3rem 2.5rem 0;
        grid-template-columns: 1fr max-content;
        column-gap: 3rem;
    }
    ${ProjectTitle}{
        text-align: initial;
    }
    ${ProjectData}{
        padding-top: .8rem;
    }
    ${FooterContainer}{
        grid-template-columns: repeat(3, 1fr);
    }
    ${FooterBackground}{
        padding: 3rem 0 3.5rem;
    }
    ${FooterLinksWrapper}{
        flex-direction: row;
        column-gap: 2rem;
    }
    ${FooterSocialsWrapper}{
        justify-self: flex-end;
    }
    ${FooterCopyright}{
        margin-top: 4.5rem;
        
    }
}

/* For large devices */
@media screen and (min-width: 1024px){
    ${HomeStyles.Header},
    ${HomeStyles.Main},
    ${FooterContainer}{
        padding: 0;
    }

    ${HomeSectionStyles.HomeImg}{
        .home__blob{
            width: 320px;
            
        }
    }
    ${HomeSectionStyles.Social}{
        transform: translateX(-6rem);
    }

    ${ServicesContainer}{
        grid-template-columns: repeat(3, 238px);
         
    }
    ${PortfolioContent}{
        grid-template-columns: 330px 1fr;
        // padding:0;
    }
    ${PortfolioContent}{
        column-gap: 1.5rem;
    }
    ${SlideArrow}{
        font-size:2.5rem;
    }
    ${Form}{
        width: 460px;
    }
    ${InputsWrapper}{
        grid-template-columns: repeat(2, 1fr);
    }

}
`;